import React from 'react';

import {GridTheme} from './GridTheme.jsx';
import {GridPlus} from './GridPlus.jsx';
import {GridThemeShared} from './GridThemeShared.jsx';

var GridView = React.createClass({
  	makeActive: function(slug){
  		this.props.makeActive(slug);
  	},
    showPreview: function(user, slug){
      this.props.showPreview(user, slug);
    },
    editTheme: function(slug, accountSlug, type){
      this.props.editTheme(slug, accountSlug, type);
    },
    popup: function(value){
      this.props.popup(value);
    },
    clone: function(action, accountSlug, slug){
      this.props.clone(action, "", "", accountSlug, slug);
    },
    browse: function(slug) {
      this.props.browse(slug);
    },
  	render: function(){
      var myclass;
      if(this.props.libName === "Layouts"){
        myclass = "theme-container layouts__grid"
      }
      else{
        myclass = "theme-container";
      }
    	return(
        	<div className= {myclass}>
              { this.props.libName === "Shared with me" || this.props.libName === "My Purchases" || this.props.libName === "Archived Packages" ?
              <GridThemeShared  themes = {this.props.themes}
                                showPreview = {this.showPreview}
                                libName = {this.props.libName}
                                clone = {this.clone}
                                browse = {this.browse}
                                editTheme = {this.editTheme} />  :
              <div>
                <GridTheme  themes= {this.props.themes}
                            makeActive = {this.makeActive}
                            showPreview = {this.showPreview}
                            editTheme = {this.editTheme}
                            libName = {this.props.libName}
                            active = {this.props.active}
                            popup = {this.popup} />
                <GridPlus />
              </div>  }
          		
        	</div>
      );
    }
});

export {GridView};



/** WEBPACK FOOTER **
 ** ./html/components/GridView.jsx
 **/